// extracted by mini-css-extract-plugin
module.exports = {"form_content_normal":"FormComponents_form_content_normal__791ag","form_label_text":"FormComponents_form_label_text__2ZI8Y"};